import useI18n from 'i18n/useI18n';
import React, { useEffect, useMemo, useReducer } from 'react';
import useCategories from 'state/categories';
import SubcategoryForm from '../../components/SubcategoryForm';
import INIT_STATE from '../../components/SubcategoryForm/initState';
import { toSubmitObject } from '../../components/SubcategoryForm/processor';
import Reducer from '../../components/SubcategoryForm/Reducer';

const Create = ({ location }) => {
    const [, categoriesDispatcher] = useCategories();
    const [formData, formDispatcher] = useReducer(Reducer, INIT_STATE());
    const dispatch = useMemo(() => (type, payload) => formDispatcher({ type, payload }), [formDispatcher]);
    const { translate } = useI18n();

    useEffect(() => {
        categoriesDispatcher.fetchStart();
    }, []);

    const submit = (e) => {
        e.preventDefault();
        const item = toSubmitObject(formData);

        categoriesDispatcher.createStart('subcategories', item);
    };

    return (
        <SubcategoryForm
            location={location}
            formData={formData}
            dispatch={dispatch}
            submit={submit}
            title={translate('New Subcategory')}
            button={translate('Create Subcategory')}
        />
    );
};

export default Create;
